import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const lsToken = localStorage.getItem("token");
    if (lsToken) {
      setToken(lsToken);
    }
  }, [token]);

  if (token) {
    return <Outlet />;
  } else {
    localStorage.clear();
    return <Navigate to="/" />;
  }
};

export default ProtectedRoutes;
